const getDateObj = (string = null) => {
    const dateObj = string ? new Date(string) : new Date()

    dateObj.setHours(0)
    dateObj.setMinutes(0)
    dateObj.setSeconds(0)
    dateObj.setMilliseconds(0)

    return dateObj
}

export default getDateObj